<template>
  <div>




    <div v-if="menuItem.length > 0 && navname !== 'solutions'" class="dropdown-container">
      <div class="dropdown-column" v-for="item in menuItem" :key="item.id">
        <img v-if="navname !== 'products'" @click="jumpCategoryPage(item.id, null)"   loading="lazy"
          style="cursor:pointer;display:block;margin:0 auto;height: 130px;object-fit: contain;"
          :src="$globalUploadArr + item.imageUrl" :alt="item.name">
        <Button  v-if="navname !== 'products'" class="column-title" style="justify-content: center;" @click="jumpCategoryPage(item.id, null)">{{ item.name }}</Button>
        <Button  v-if="navname === 'products'" class="column-title" style="justify-content: flex-start;" @click="jumpCategoryPage(item.id, null)">{{ item.name }}</Button>
        <ul class="column-items">
          <li v-for="subItem in item.children" :key="subItem.id" class="column-child-title">
            <a   v-if="subItem.status === 1" @click="jumpCategoryPage(item.id, subItem.id)"> <span
               >{{ subItem.name }}</span><i
                class="el-icon-arrow-right"></i></a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div v-else-if="menuItem.length > 0 && navname === 'solutions'" class="dropdown-container-flex">
        <div style="display: flex;flex-direction: column;width: 100%;justify-content: flex-start;" v-for="item in menuItem" :key="item.id">
          <div class="dropdown-item" >
            <div class="column-title" style="cursor: none;border-bottom: 1px solid #ddd; width: 100%;text-align: left;padding: 10px 30px;margin:5px 0;justify-content: flex-start;" >{{ item.name }}</div>
          </div>


          <ul class='sub-category'  style="display: flex;flex-direction: row;gap:30;list-style: none;flex-wrap: wrap;margin-bottom:30px;">
            <li :key="subItem.id" v-for="subItem in item.children" style="margin:0 20px">
              <img v-if="navname === 'solutions'" @click="jumpCategoryPage(subItem.id, null)" 
          style="cursor:pointer;display:block;margin:0 auto; width:180px;height: 120px;object-fit: contain;"
          :src="$globalUploadArr + subItem.imageUrl" :alt="subItem.name">
              <Button class="column-title" @click="jumpCategoryPage(subItem.id, null)"
                @mouseenter="activeChilds = subItem.solutions"> <i class="el-icon-arrow-right"
                  ></i><span class="column-child-title">{{ subItem.name }}</span></Button>
                  <a v-if="subItem.status === 1" @click="jumpCategoryPage(subItem.id, null)" style="cursor:pointer;"> <i
                class="el-icon-arrow-right"></i><span
                class="column-child-title">{{ subItem.name }}</span></a>
            </li>
          </ul>
        </div>
    </div> -->
    <!-- <div v-else-if="menuItem.length > 0 && navname === 'solutions'" class="dropdown-container-flex-row">
        <div style="display: flex;flex-direction: column;justify-content: flex-start;">
            <div  v-for="item in menuItem" :key="item.id"  style="cursor: pointer; text-align: left;padding: 10px;margin:5px 0;justify-content: flex-start;min-width:150px;" >
            <Button  class="column-title-solution"   :class="{ 'active': item.id === currSolutionCategory.id }" style="justify-content: flex-start;" @click.stop="changeSolutionCategory(item)">{{ item.name }}</Button>
         </div>
        </div>
         <ul class='sub-category'  style="display: flex;flex-direction: row;gap:30;list-style: none;flex-wrap: wrap;margin-bottom:30px;width:800px;">
            <li :key="subItem.id" v-for="subItem in currSolutionCategory.children" style="margin:0 20px">
              <img v-if="navname === 'solutions'" @click="jumpCategoryPage(subItem.id, null)" 
          style="cursor:pointer;display:block;margin:0 auto; width:180px;height: 120px;object-fit: contain;"
          :src="$globalUploadArr + subItem.imageUrl" :alt="subItem.name">
                  <a v-if="subItem.status === 1" @click="jumpCategoryPage(subItem.id, null)" style="cursor:pointer;"> <i
                class="el-icon-arrow-right"></i><span
                class="column-child-title">{{ subItem.name }}</span></a>
            </li>
          </ul>
    </div> -->
    <!-- <div v-else-if="menuItem.length > 0 && navname === 'solutions'" class="dropdown-container-flex-row">
        <div style="display: flex;flex-direction: column;justify-content: space-around;background-color: #f5f9ff;">
           <div  v-for="item in menuItem" :key="item.id"  class="column-title-container" :class="{ 'active': item.id === currSolutionCategory.id }">
            <Button  class="column-title-solution"   :class="{ 'active': item.id === currSolutionCategory.id }" style="justify-content: flex-start;" @click.stop="changeSolutionCategory(item)">{{ item.name }}</Button>
         </div>
        </div>
        <div style="background-color: #fff;padding:20px;width:100%; ">
          <ul class='sub-category'  style="display: flex;flex-direction: row;list-style: none;flex-wrap: wrap;align-items: flex-start;gap:10px;">
            <li :key="subItem.id" v-for="subItem in currSolutionCategory.children" style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
              <img v-if="navname === 'solutions'" @click="jumpCategoryPage(subItem.id, null)" 
          style="cursor:pointer;display:block;margin:0 20px; width:30px;height: 30px;object-fit: contain;"
          :src="$globalUploadArr + subItem.imageUrl" :alt="subItem.name">
                  <a v-if="subItem.status === 1" @click="jumpCategoryPage(subItem.id, null)" style="cursor:pointer;"> <i
                class="el-icon-arrow-right"></i><span
                class="column-child-title">{{ subItem.name }}</span></a>
            </li>
          </ul>
        </div>
         
    </div> -->
    <div v-else-if="menuItem.length > 0 && navname === 'solutions'" class="dropdown-container-flex-row">
        <div   v-for="item in menuItem" :key="item.id" style="display: flex;flex-direction: row;justify-content: flex-start;background-color: #fff;">
           <div  class="column-title-container" >
            <Button  class="column-title-solution"    style="justify-content: flex-end;padding: 20px 0;text-align: right;cursor: pointer;" @click.stop="changeSolutionCategory(item)">{{ item.name }}</Button>
         </div>
         <div style="background-color: #fff;padding: 20px;width:100%; ;">
          <ul class='sub-category'  style="display: flex;flex-direction: row;list-style: none;flex-wrap: wrap;align-items: flex-start;gap: 0 20px;border-left:2px solid #eee;padding-left:20px;">
            <li :key="subItem.id" v-for="subItem in item.children" style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;width:120px;">
              <!-- <img v-if="navname === 'solutions'" @click="jumpCategoryPage(subItem.id, null)" 
          style="cursor:pointer;display:block;margin:0 ; width:30px;height: 30px;object-fit: contain;"
          :src="$globalUploadArr + subItem.imageUrl" :alt="subItem.name"> -->
                  <a  v-if="subItem.status === 1" @click="jumpCategoryPage(subItem.id, null)" style="cursor:pointer;"><i class="el-icon-arrow-right"></i> <span
                    class="column-child-title" >{{ subItem.name }}</span></a>
            </li>
          </ul>
        </div>
        </div>
       
         
    </div>

  </div>
</template>

<script>

import { productApi, solutionApi } from '@/api'
import CategoryNavigation from './product/CategoryNavigation.vue'
import { Button } from 'element-ui'

export default {
  name: 'NavmenuItem',
  props: {
    navname: {
      type: String
    }
  },
  components: {
    CategoryNavigation
  },
  watch: {
    navname(nav) {
      this.menuItem = []
      if (nav !== null) {
        this.getMenuItem(nav)
      }
    }
  },
  created() {

  },
  computed: {
    currNav() {
      var currChildCategory = []
      this.menuItem.map(item => {
        if (item.id === this.activeNav) {
          currChildCategory = item.children
        }
      })
      return currChildCategory
    }
  },
  data() {
    return {
      currSolutionCategory:null,
      selectedTopCategory: null,
      activeChilds: "",
      menuItem: [],
    }
  },
  methods: {
    jumpCategoryPage(id = null, childId = null) {
      if (this.navname === 'products') {
        if (this.navname === 'products' && !childId) {
          this.$router.push({ path: "/products/category", query: { id: id } })
        } else {
          this.$router.push({ path: "/products/productlist", query: { id: childId } })
        }
      }
      if (this.navname === 'solutions') {
        if (this.navname === 'solutions' && id) {
          this.$router.push({ path: "/solutions/category", query: { id: id } })
        } else {
          this.$router.push({ path: "/solutions/index" })
        }
      }
      if (this.navname === 'services') {
        if (this.navname === 'services' && id) {
          this.$router.push({ path: "/services/index", query: { id: id } })
        } else {
          this.$router.push({ path: "/services/index" })
        }
      }
      if (this.navname === 'concact') {
          this.$router.push({ path: "/contact" })
        }
    },
    selectTopCategory(categoryId) {
      this.selectedTopCategory = categoryId
      // 根据一级分类筛选二级分类
      // 这里可以添加筛选逻辑
    },
    
    changeSolutionCategory(item){
      
      this.$router.push({ path: "/solutions/index" ,query :{id:item.id}})
    },
    async getMenuItem(nav) {
      //console.log("nav", nav)

      try {
        if (nav === 'products') {
          //console.log(this.$store.state.topProductCategorys)
          if (this.$store.state.topProductCategorys.length > 0) {

            this.menuItem = this.$store.state.topProductCategorys
          } else {
            const [productsCategoryRes] = await Promise.all([
              productApi.getProductCategories()
            ])

            this.$store.commit('SET_TOPPRODUCTCATEGORYS', productsCategoryRes.items);
            this.menuItem = productsCategoryRes.items || productsCategoryRes
          }
        }

        if (nav === 'solutions') {

          //console.log(this.$store.state.solutionCategorys)
          if (this.$store.state.solutionCategorys.length > 0) {
            this.menuItem = this.$store.state.solutionCategorys
          } else {
            const [solutionCategoryRes] = await Promise.all([
              solutionApi.getCategorys()
            ])

            this.menuItem = solutionCategoryRes.items || solutionCategoryRes
            

            this.$store.commit('SET_SOLUTIONCATEGORYS', solutionCategoryRes.items);
          }
          
          this.currSolutionCategory = this.menuItem[0]
        }

        if (nav === 'services') {

          //console.log(this.$store.state.serviceCategorys)
          if (this.$store.state.serviceCategorys.length > 0) {
            this.menuItem = this.$store.state.serviceCategorys
          } else {
            const [serviceCategoryRes] = await Promise.all([
              solutionApi.getServiceCoategories()
            ])

            this.menuItem = serviceCategoryRes.items || serviceCategoryRes
            this.$store.commit('SET_SERVICECATEGORYS', serviceCategoryRes.items);
          }
        }

      } catch (error) {
        console.error('数据加载失败:', error)
      } finally {
        this.loading = false
      }



    }
  },
}
</script>

<style scoped lang="scss">
.menu-sub-section {
  flex: 30%;

  h4 {
    color: #666;
    font-size: 14px;
    margin: 0 0 15px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

.sub-category {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-bottom: 10px;

    a {
      color: var(--primary-title);
      text-decoration: none;
      font-size: 15px;
      transition: color 0.3s;

      &:hover {
        color: #0071b3;
        text-decoration:underline;
      }
    }
  }
}

.dropdown-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 2fr));

  max-width: 1000px;
  min-width: 768px;
  padding: 20px;
  width: fit-content;
  min-width: 600px;
  flex-wrap: wrap;
  border-radius: 0 0 5px 5px;
  box-shadow: 1px 15px 20px 0px #75757544;
  background-color: #fff;
  // border: 1px solid #d1d1d1c4;

}

.dropdown-container-flex {
  display: flex;
  padding: 20px;
  max-width: 1200px;
  min-width: 768px;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  box-shadow: 1px 15px 20px 0px #75757544;
  flex-direction: column;
  // border: 1px solid #d1d1d1c4;

}
.dropdown-container-flex-row {

  display: flex;
  max-width: 860px;
  min-width: 840px;
  flex-wrap: nowrap;
  border-radius: 0 0 5px 5px;
  box-shadow: 1px 15px 20px 0px #75757544;
  flex-direction: column;
}

.dropdown-container:last-child {
  margin-right: auto;
}

.column-child-title {
  white-space: nowrap;
  font-size:15px;
  overflow: hidden;
  color:var(--accent);
  text-overflow: ellipsis;
}


.dropdown-item {
  white-space: nowrap;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: flex-end;
  text-align: left;
  justify-items: center;
  vertical-align: middle;

}

.dropdown-column {
  white-space: nowrap;
  flex: 1;
  text-align: left;
  padding: 10px;

  &:not(:last-child) {
    border-right: 1px solid #eee;
  }

}

.column-title {
  color:#666;
  text-align: center;
  width: 100%;
  background-color: transparent;
  font-size:17px;
  padding: 5px 0;
  cursor: pointer;
  border: 0px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eee;  
  &:hover {
       
       color: var(--accent);
         // background: #0962d0;
         // box-shadow: 0px 0px 10px 1px #badbfd;
         font-weight: 600;
       }
}
.column-title-container{
  cursor: pointer; 
  text-align: left;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-start;
  min-width:100px;
  &.active {
    border-right:2px solid #1046b3b4;
        background: #fff;
         font-weight: 600;
       }
}
.column-title-solution {
  color: #666;
  text-align: center;
  width: 100%;
  height: 100%;;
  background-color: transparent;
  font-size:17px;
 // cursor: pointer;
  border: 0px;
  font-weight: 600;
  
  &:hover {
      color: var(--accent);
         font-weight: 600;
       }
  &.active {
       
  color: var(--accent);
    // box-shadow: 0px 0px 10px 1px #badbfd;
    font-weight: 600;
  }
}
.column-items {
  list-style: none;
  margin: 0 0;
  padding: 0 0;
  cursor: pointer;

  li {
    margin: 10px 0px;

    text-overflow: ellipsis;
    overflow: hidden;

    a {
      color: #0b5aafe6;
      text-decoration: none;
      transition: color 0.3s;
      font-size:15px;
      padding: 3px 0;
      padding: 0;
      text-overflow: ellipsis;
      overflow: hidden;

      &:hover {
        text-decoration: underline;
        color: #0962d0;
      }
    }
  }
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 992px) {
  .dropdown-container {
    flex-wrap: wrap;
  }

  .dropdown-column {
    flex: 0 0 50%;
    margin-bottom: 20px;

    &:nth-child(2n) {
      border-right: none;
    }
  }
}

@media (max-width: 768px) {
  .main-nav {
    flex-wrap: wrap;
  }

  .main-nav>li {
    flex: 0 0 50%;
  }

  .dropdown-column {
    flex: 0 0 100%;
    border-right: none !important;
  }
}


.top-categories {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  padding: 10px 20px;
  height: 100%;

  .category-tabs {
    display: flex;
    gap: 10px;
    flex-direction: row;
    white-space: nowrap;
    flex-wrap: wrap;

    .category-tab {
      border-radius: 20px;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;
      color:var(--accent);
      display: flex;
      flex-direction: column;
      justify-content: center;
      justify-items: center;
      margin: 10px;

      &:hover {
        color: var(--accent);
        // background: #ffffff;
      }

      &.active {
        color: var(--accent);
        font-weight: 600;
        //background: #0962d0;
        box-shadow: 0px 0px 10px 1px #badbfd;
        font-weight: 400;
      }
    }
  }
}
</style>